import {portfolioActionTypes} from "./portfolio.actionTypes";

export const initialState = {
  data: {
    total: 0,
    page: 0,
    probes: [],
    liquidity: [],
  },
  selectedLiveProbe: null,
  errors: undefined,
  activeMarketLoading: false,
  closedMarketDetailProbe: null,
  selectedClosedProbe: null,
  closedMarketLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case portfolioActionTypes.ACTIVE_MARKETS_LOADING: {
      return {...state, activeMarketLoading: true};
    }
    case portfolioActionTypes.ACTIVE_MARKETS_SUCCESS: {
      return {...state, activeMarketLoading: false, data: action.payload};
    }
    case portfolioActionTypes.ACTIVE_MARKETS_SUCCESS1: {
      return {...state, activeMarketLoading: false, data1: action.payload};
    }
    case portfolioActionTypes.ACTIVE_MARKETS_LIQUIDITY: {
      return {
        ...state,
        activeMarketLoading: false,
        liquidityDetail: action.payload,
      };
    }
    case portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST: {
      return {
        ...state,
        activeMarketLoading: false,
        portfolioDataContest: action.payload,
      };
    }
    case portfolioActionTypes.ACTIVE_MARKETS_SUCCESS_CONTEST1: {
      return {
        ...state,
        activeMarketLoading: false,
        portfolioDataContest1: action.payload,
      };
    }
    case portfolioActionTypes.ACTIVE_MARKETS_ERROR: {
      return {...state, activeMarketLoading: false, errors: action.payload};
    }
    case portfolioActionTypes.CLOSED_MARKETS_LOADING: {
      return {...state, closedMarketLoading: true};
    }
    case portfolioActionTypes.CLOSED_MARKETS_SUCCESS: {
      return {
        ...state,
        closedMarketLoading: false,

        closedMarketDetails:
          action.payload.page === 1
            ? action.payload.historyRows
            : [...state.closedMarketDetails, ...action.payload.historyRows],
        closedMarketDetailsPage: action.payload.historyRows.length
          ? action.payload.page
          : state.closedMarketDetailsPage,
      };
    }
    case portfolioActionTypes.CLOSED_MARKETS_ERROR: {
      return {...state, closedMarketLoading: false, errors: action.payload};
    }
    case portfolioActionTypes.CLOSED_MARKETS_SUCCESS_PROBE: {
      return {
        ...state,
        loading: false,
        closedMarketDetailProbe: action.payload,
      };
    }
    case portfolioActionTypes.CLOSED_MARKETS_ERROR_PROBE: {
      return {...state, loading: false, errors: action.payload};
    }
    case portfolioActionTypes.SELECTED_CLOSED_PROBE: {
      return {...state, selectedClosedProbe: action.payload};
    }
    default: {
      return state;
    }
  }
};

export {reducer as portfolioReducer};
